import { useLocation } from "react-router-dom";
import { motion } from "framer-motion";
import { WhatsAppIcon } from "@/components/icons";
import { useSettings } from "@/hooks/useSettings";

export default function FloatingWhatsApp() {
  const settings = useSettings();
  const { pathname } = useLocation();
  if (pathname.startsWith("/admin")) return null;

  const href = settings.whatsapp_url || "https://wa.me/995591063123";

  return (
    <motion.a
      href={href}
      target="_blank"
      rel="noreferrer"
      data-testid="floating-whatsapp-btn"
      aria-label="WhatsApp-ით დაგვიკავშირდი"
      initial={{ opacity: 0, scale: 0.6 }}
      animate={{ opacity: 1, scale: 1 }}
      transition={{ delay: 1, duration: 0.35, type: "spring", stiffness: 260, damping: 18 }}
      whileHover={{ scale: 1.08 }}
      whileTap={{ scale: 0.94 }}
      className="fixed bottom-5 right-5 sm:bottom-7 sm:right-7 z-50 w-14 h-14 rounded-full bg-[#10121A]/90 backdrop-blur border border-[#D4AF37]/50 shadow-[0_8px_30px_rgba(0,0,0,0.5)] flex items-center justify-center text-[#D4AF37] hover:border-[#D4AF37] hover:text-[#E5C378] transition-colors"
    >
      <span className="absolute inset-0 rounded-full bg-[#D4AF37]/15 animate-ping [animation-duration:2.5s]" aria-hidden="true" />
      <WhatsAppIcon className="relative w-7 h-7" />
    </motion.a>
  );
}
